import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Notification =
/*#__PURE__*/
function () {
  function Notification() {
    _classCallCheck(this, Notification);

    this.$events = void 0;
    this.$events = {};
  }

  _createClass(Notification, [{
    key: "dispatch",
    value: function dispatch(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var event = this.$events[name];
      if (!event) return;
      event.forEach(function (fn) {
        return fn.apply(void 0, args);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(name, fn) {
      if (!this.$events[name]) this.$events[name] = [];
      var events = this.$events[name];
      if (events.includes(fn)) return;
      events.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(name, fn) {
      if (!this.$events[name]) return;
      if (fn) this.$events[name] = this.$events[name].filter(function (e) {
        return e !== fn;
      });else delete this.$events[name];
    }
  }]);

  return Notification;
}();

export { Notification as default };